<script setup>
import { ref, computed, defineProps } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { User, ArrowDown, Phone, Menu } from '@element-plus/icons-vue';
import font from '@/assets/font.png'
import { useUserStore } from '@/store/user';

const userStore = useUserStore();

defineProps({
  showMenu: {
    type: Boolean,
    default: true
  }
})

const route = useRoute()
const router = useRouter();
const onRoutes = computed(() => route.path)

// 直接使用 store 响应式数据
const token = computed(() => userStore.token);
const userInfo = computed(() => userStore.user);

const contactDialogVisible = ref(false);

const handleLogin = () => {
  window.open('/login', '_blank');
};

const handleCommand = (command) => {
  if (command === 'logout') handleLogout();
}

const toMyWorkbench = () => {
  if (!token.value) return;
  const role = userInfo.value?.role;
  if (role === 'admin') {
    window.open('/activity-manage', '_blank');
  } else if (role === 'student') {
    window.open('/my-work-list', '_blank');
  } else if (role === 'reviewer') {
    window.open('/review', '_blank');
  } else if (role === 'employee') {
    window.open('/emp-sti-manage', '_blank');
  }
}

// 退出登录（修复版）
const handleLogout = () => {
  userStore.logout();
  router.push('/login');
};

const toHome = () => {
  router.push('/');
}

const toContactUs = () => {
  router.push('/contact-us');
}
</script>

<template>
  <nav class="navbar">
    <img :src="font" alt="font-icon" @click="toHome" style="width: 120px; height: 26px;"/>
    
    <div style="width: 100%;" v-if="showMenu">
      <el-menu 
        router 
        :default-active="onRoutes" 
        mode="horizontal"
        :ellipsis="false"
      >
        <el-menu-item index="/notice">新闻公告</el-menu-item>
        <el-menu-item index="/activity-list">创新赛事</el-menu-item>
        <el-menu-item index="/work-track">科创作品跟踪</el-menu-item>
      </el-menu>
    </div>

    <div class="user-info">

      <el-button type="primary" v-if="token" @click="toMyWorkbench" :icon="Menu">
        工作台
      </el-button>
      <el-dropdown trigger="click" @command="handleCommand" v-if="token">
        <span class="username">
          {{ userInfo.username }}
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <el-button type="text" class="login-btn" @click="handleLogin" v-if="!token">
        登录
      </el-button>
      <span class="divider-line" v-if="showMenu">|</span>
      <!-- <div class="contact-btn" @click="contactDialogVisible = true">
        <el-icon><phone /></el-icon>
        联系我们
      </div> -->
      <!-- <span style="margin-right: 5px;">📞</span>联系我们 -->
      <el-button type="text" class="login-btn" @click="toContactUs" :icon="Phone" v-if="showMenu">
        <!-- <el-icon><phone /></el-icon> -->
        联系我们
      </el-button>
    </div>
  </nav>

  <el-dialog v-model="contactDialogVisible" title="联系我们 / 申请入驻" width="1000px" center>
    <!-- <div style="text-align: center; padding: 10px 0;">
      <p style="font-size: 15px; color: #606266; margin-bottom: 24px; line-height: 1.6;">
        如果您是外部学校的老师，想要为本校开通<b>机构管理员账号</b>，请微信扫码联系人工客服：
      </p>
      <div style="width: 160px; height: 160px; background: #f5f7fa; border: 1px dashed #dcdfe6; margin: 0 auto 16px; display: flex; flex-direction: column; justify-content: center; align-items: center; border-radius: 8px;">
        <span style="font-size: 40px;">💬</span>
        <span style="font-size: 12px; color: #909399; margin-top: 8px;">[ 微信扫码添加好友 ]</span>
      </div>
      <p style="font-size: 15px; font-weight: bold; color: #303133; margin: 8px 0;">微信号：AI_Space_Support</p>
      <el-divider style="margin: 20px 0;"></el-divider>
      <p style="font-size: 13px; color: #909399; line-height: 1.5;">
        📞 服务电话：400-123-4567 (工作日 9:00-18:00)<br>
        加好友请备注：<b>学校名称 - 老师姓名</b>
      </p>
    </div> -->
    <div class="main-layout">      
      <div class="left-card">
        <h3 class="section-title"><span>📞</span>学校开通与技术支持</h3>
        <div class="tips-box">
          <strong>💡 快捷开通小贴士：</strong><br>
          外校教职工申请机构管理员账号，加微信时请务必备注：<b>“学校名称 - 老师姓名”</b>，以便我们快速为您后台开通。
        </div>
        <div class="qrcode-box">
          <span class="qrcode-img">💬</span>
          <span style="font-size: 12px; color: #909399; margin-top: 8px;">[ 微信扫码添加客服 ]</span>
        </div>
        <div class="wx-account">微信号：AI_Space_Support</div>
        <el-divider style="margin: 24px 0;"></el-divider>
        <div class="info-item">
          <span class="info-icon">☎️</span>
          <span><strong>服务热线：</strong>400-123-4567 (工作日 9:00 - 18:00)</span>
        </div>
        <div class="info-item">
          <span class="info-icon">✉️</span>
          <span><strong>官方邮箱：</strong>support@ai-space.edu.cn</span>
        </div>
      </div>
      <div class="right-card">
        <h3 class="section-title"><span>❓</span>常见问题自助解答 (FAQ)</h3>
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item title="1. 我是外校老师，如何获得学校管理员账号？" name="1">
            <div style="color: #5e6d82; line-height: 1.6;">
              目前平台采取受邀/人工入驻制。您可以通过左侧的微信或电话联系平台运营人员，提供您的<b>学校名称及教师资格证明</b>，我们将在 5 分钟内为您人工初始化账号与密码。
            </div>
          </el-collapse-item>
          <el-collapse-item title="2. 学生（小学生）可以自己注册账号吗？" name="2">
            <div style="color: #5e6d82; line-height: 1.6;">
              为了保障未成年人信息安全，系统<b>不支持小学生自主注册</b>。所有学生账号均需由本校的管理员老师在后台批量导入，或由家长代为绑定。
            </div>
          </el-collapse-item>
          <el-collapse-item title="3. 别的学校发布的“公开活动”，我们的学生怎么参加？" name="3">
            <div style="color: #5e6d82; line-height: 1.6;">
              全平台公开的活动会展示在您的学校后台“公开活动广场”中。您作为学校管理员，只需点击<b>“引入本校”</b>并勾选想要参与的学生，学生端即可立刻收到活动通知。
            </div>
          </el-collapse-item>
          <el-collapse-item title="4. 账号密码忘记了怎么找回？" name="4">
            <div style="color: #5e6d82; line-height: 1.6;">
              老师和管理员如忘记密码，请点击登录页面的“忘记密码”通过绑定手机号重置。如果是学生忘记密码，可联系本校的管理老师在后台一键“重置密码”。
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <template #footer>
      <el-button type="primary" @click="contactDialogVisible = false" style="width: 100px;">知道了</el-button>
    </template>
  </el-dialog>
</template>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: grid;
  grid-template-areas: "left center right";
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  background-color: #fff;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.logo {
  font-size: 18px;
  font-weight: bold;
  color: #165DFF;
  margin-right: auto;
}

.ai-text {
  font-family: "Arial Black", sans-serif;
  font-size: 25px;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  background-image: url('@/assets/home1.png');
  background-size: 50px 20px;
  -webkit-text-stroke: 1px #6680e7;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  grid-area: right;
  justify-self: end;
  font-size: 18px;
  height: 100%;   
}

.username {
  color: #666;
  /* margin-left: 20px;
  margin-right: 20px; */
  display: flex;
  justify-content: center;
  align-items: center; 
  cursor: pointer;
}

.login-btn {
  color: #165DFF;
  /* margin-right: 10px; */
  font-size: 15px;
}
.logout-btn {
  color: #f56c6c;
}

/* 垂直分割线 */
.divider-line {
  color: #dcdfe6;
  font-size: 15px;
  user-select: none;
  /* margin-right: 10px; */
  align-self: center;
  margin-bottom: 3px;
}

/* 联系我们按钮 */
.contact-btn {
  font-size: 15px;
  color: #409eff; /* 调整为清爽的科技蓝 */
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s;
}
.contact-btn:hover {
  color: #8abff8;
}




/* 两栏布局 */
.main-layout { 
  display: flex; 
  gap: 24px; 
}
.left-card { 
  flex: 4; 
  background: #fff; 
  border-radius: 8px; 
  padding: 32px; 
  box-shadow: 0 2px 10px rgba(0,0,0,0.03); 
}
.right-card { 
  flex: 5; 
  background: #fff; 
  border-radius: 8px; 
  padding: 32px; 
  box-shadow: 0 2px 10px rgba(0,0,0,0.03); 
}

.section-title { 
  font-size: 18px; 
  font-weight: 600; 
  color: #1f2329; 
  margin-top: 0; 
  margin-bottom: 24px; 
  display: flex; 
  align-items: center; 
  gap: 8px; 
}

/* 客服名片样式 */
.qrcode-box { 
  width: 180px; 
  height: 180px; 
  background: #f5f7fa; 
  border: 1px dashed #cdd0d6; 
  border-radius: 8px; 
  margin: 24px auto; 
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  align-items: center; 
  position: relative; 
}
.qrcode-img { 
  font-size: 40px; 
}
.wx-account { 
  text-align: center; 
  font-size: 16px; 
  font-weight: bold; 
  color: #333; 
  margin: 12px 0; 
}
.tips-box { 
  background-color: #ecf5ff; 
  border-left: 4px solid #409eff; 
  padding: 12px 16px; 
  border-radius: 4px; 
  font-size: 13px; 
  color: #409eff; 
  line-height: 1.5; 
  margin-bottom: 24px; 
}

/* 电话邮件样式 */
.info-item { 
  display: flex; 
  align-items: center; 
  gap: 12px; 
  margin-bottom: 16px; 
  font-size: 14px; 
  color: #646a73; 
}
.info-icon { 
  font-size: 18px; 
  color: #409eff; 
}
</style>